<template>
  <div>
    <NavBar />

    <transition name="fade-slide" appear>
      <div class="page-wrapper">
        <div class="header-section">
          <h1 class="main-title">HE Customer Service Portal</h1>
          <p class="subtitle">
            Support patients, clinics, and providers with real-time information
          </p>
        </div>

        <transition name="fade" appear>
          <div class="login-container">
            <h2 class="text-center">Login</h2>
            <form @submit.prevent="handleLogin">
              <div class="form-group">
                <label for="email">Email</label>
                <input
                  type="email"
                  id="email"
                  v-model="email"
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div class="form-group">
                <label for="password">Password</label>
                <input
                  type="password"
                  id="password"
                  v-model="password"
                  placeholder="Enter your password"
                  required
                />
              </div>

              <button type="submit">Login</button>

              <transition name="fade">
                <div v-if="errorMessage" class="error-message">
                  {{ errorMessage }}
                </div>
              </transition>
            </form>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import NavBar from "@/components/RegNavbar.vue";
import axios from "axios";

export default {
  name: "HomeView",
  components: { NavBar },
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
    };
  },
  methods: {
    async handleLogin() {
      if (this.email && this.password) {
        try {
          const response = await axios.post(`${process.env.VUE_APP_URL}/api/login`, {
            email: this.email,
            password: this.password,
          });

          const token = response.data.token;
          localStorage.setItem("token", token);
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          this.$router.push("/dashboard");
        } catch (error) {
          this.errorMessage =
            error.response?.data?.message || "Login failed. Try again.";
        }
      } else {
        this.errorMessage = "Please fill in all fields.";
      }
    },
  },
};
</script>

<style scoped>
/* Animations */
.fade-slide-enter-active {
  animation: fadeInUp 0.6s ease-out;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Layout */
.page-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 64px);
  padding: 40px 20px;
  background: linear-gradient(135deg, #f7fcf8, #f2f4ff, #ffffff);
}

/* Header */
.header-section {
  text-align: center;
  margin-bottom: 40px;
  animation: fadeInUp 0.8s ease-out;
}

.main-title {
  font-size: 36px;
  font-weight: 700;
  color: #4a4a4a; /* dark gray from logo */
}

.subtitle {
  color: #6d4fa1; /* purple tone from logo */
  font-size: 16px;
  margin-top: 10px;
}

/* Login Box */
.login-container {
  width: 100%;
  max-width: 420px;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

h2 {
  margin-bottom: 24px;
  font-size: 24px;
  color: #4a4a4a;
}

.form-group {
  margin-bottom: 20px;
  width: 100%;
}

label {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  color: #4a4a4a;
}

input {
  padding: 12px;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 100%;
  box-sizing: border-box;
  transition: border 0.3s;
}

input:focus {
  border-color: #6d4fa1; /* purple highlight */
  outline: none;
}

/* Button */
button {
  padding: 12px;
  background-color: #5fa83c; /* green from logo */
  color: white;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.2s, transform 0.2s;
}

button:hover {
  background-color: #4d8a31;
  transform: scale(1.02);
}

/* Error Message */
.error-message {
  margin-top: 12px;
  text-align: center;
  color: #cf1b2b; /* red from logo */
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
